import { render, staticRenderFns } from "./configure-type.vue?vue&type=template&id=68764cef&scoped=true&"
import script from "./configure-type.vue?vue&type=script&lang=ts&"
export * from "./configure-type.vue?vue&type=script&lang=ts&"
import style0 from "./configure-type.vue?vue&type=style&index=0&id=68764cef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68764cef",
  null
  
)

export default component.exports